/*
* Copyright (C) Regione Lombardia
*/
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatalistAnagrafica, DocumentoProgetto, LeggiProgetto, Opera, Progetto } from '@models';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';

@Component({
    selector: 'app-dettaglio-progetto',
    templateUrl: './dettaglio-progetto.component.html'
})
export class PagesGestioneProgettoDettaglioProgettoComponent implements OnInit {

    public progetto: Progetto;
    public criteriaForm: FormGroup;
    public datalist: DatalistAnagrafica;
    public leggiProgettoList: LeggiProgetto[] = [];
    public documentoProgettoList: DocumentoProgetto[] = [];
    public opereAssociateList: Opera[] = [];

    constructor(
        private progettoService: ProgettoService,
        private utilsService: UtilsService,
        private router: Router,
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.progetto = this.route.snapshot.data['additionalInformation'].progetto;
        this.datalist = this.route.snapshot.data['additionalInformation'].datalist;
        this.leggiProgettoList = this.route.snapshot.data['additionalInformation'].leggiProgetto;
        this.documentoProgettoList = this.route.snapshot.data['additionalInformation'].documentoProgetto;
        this.opereAssociateList = this.route.snapshot.data['additionalInformation'].opereAssociate;
        this.criteriaForm = this.progettoService.generateFormProgetto(this.progetto);
    }

    public goToModifica() {
        this.router.navigate(['modifica'], { relativeTo: this.route });
    }

    public deleteProgetto() {
        this.progettoService.delete(this.progetto.idProgetto).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.router.navigate(['..'], { relativeTo: this.route });
            }
        });
    }

}
